import { createAppAsyncThunk } from '../appAsyncThunk';
import { uploadData } from 'aws-amplify/storage';
import { get } from 'aws-amplify/api';
import { UploadFile } from './types';

export const uploadFileThunk = createAppAsyncThunk(
    'general/uploadFileThunk', async ({ fileName, file, callback, accessLevel }: UploadFile) => {
        const result = await uploadData({
            key: fileName,
            data: file,
            options: {
                accessLevel,
                onProgress: ({ transferredBytes, totalBytes }) => {
                    if (totalBytes && callback) {
                        callback(`${Math.round(transferredBytes / totalBytes) * 100} %`);
                    }
                }
            }
        }).result;

        return result;
    });

export const getCountriesThunk = createAppAsyncThunk(
    'general/getCountriesThunk', async () => {

        const restOperation = await get({
            apiName: 'emrCountries',
            path: '/emrCountries/{proxy+}',
        }).response;

        const response = await restOperation.body.json();
        return response as any;
    });

export const getStatesThunk = createAppAsyncThunk(
    'general/getStatesThunk', async () => {

        const restOperation = await get({
            apiName: 'emrStates',
            path: '/emrStates/{proxy+}',
        }).response;

        const response = await restOperation.body.json();
        return response as any;
    });

export const getCitiesThunk = createAppAsyncThunk(
    'general/getCitiesThunk', async (city: string) => {

        const restOperation = await get({
            apiName: 'emrCity',
            path: '/emrCity/{proxy+}',
            options: {
                queryParams: { city }
            }
        }).response;

        const response = await restOperation.body.json();
        return response as any;
    });

